import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "../../utils/urls";

export const noticeStudentApi = createApi({
  reducerPath: "noticeStudentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
    tagTypes: ["Notice"],
  }), // schedules
  endpoints: (builder) => ({
    getNotices: builder.query({
      query: () => ({ url: `student-notices`, method: "GET" }),
      providesTags: ["Notice"],
    }),
  }),
});

export const { useGetNoticesQuery } = noticeStudentApi;
